export const escapeHtml = (value: string | number): string => String(value)
  .replaceAll('&', '&amp;')
  .replaceAll('<', '&lt;')
  .replaceAll('>', '&gt;')
  .replaceAll('"', '&quot;')
  .replaceAll("'", '&#039;');

export const money = (minor: number): string => new Intl.NumberFormat('tr-TR', {
  style: 'currency',
  currency: 'TRY',
  maximumFractionDigits: 0
}).format(minor / 100);

export const shortDate = (iso: string | null): string => iso
  ? new Intl.DateTimeFormat('tr-TR', { day: '2-digit', month: 'short', year: 'numeric' }).format(new Date(iso))
  : '—';

export const time = (iso: string): string => new Intl.DateTimeFormat('tr-TR', {
  hour: '2-digit',
  minute: '2-digit'
}).format(new Date(iso));

export const initials = (name: string): string => name.split(' ').map((part) => part[0]).filter(Boolean).slice(0, 2).join('').toLocaleUpperCase('tr-TR');

export const statusLabel = (status: string): string => ({
  scheduled: 'Planlandı', confirmed: 'Onaylandı', arrived: 'Geldi', waiting: 'Bekliyor', in_service: 'Hizmette', completed: 'Tamamlandı', cancelled: 'İptal', no_show: 'Gelmedi',
  paid: 'Ödendi', partial: 'Kısmi', partially_paid:'Kısmi ödendi', draft:'Taslak', pending: 'Bekliyor', approved:'Onaylandı', declined:'Reddedildi'
}[status] ?? status);

export const paymentMethodLabel = (method: string): string => ({
  cash: 'Nakit', bank_transfer: 'Havale', card: 'Kart / POS', card_simulation: 'POS Simülasyonu', other:'Diğer'
}[method] ?? method);

/* Unit costs (e.g. per ml) need cents; sales totals stay whole-lira. */
export const moneyPrecise = (minor: number): string => new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(minor / 100);

/* v1.0-P2: the edition is a product label carried by the contract (demo vs local production data); the renderer never learns which persistence answers. */
export const isDemoEdition = (info: { edition: string }): boolean => info.edition === 'showcase';
